import { tr as __tr, useLocale as __useLocale } from "../i18n/runtime";
import React from 'react';
import { Plane, Hotel, Globe, Briefcase } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
const HeroSection = () => {
  __useLocale();
  const {
    t,
    language
  } = useLanguage();
  return <div className="relative min-h-[70vh] overflow-hidden bg-gradient-to-br from-[#6B5B95] via-[#5B4B85] to-[#4A3F75]" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Floating icons */}
        <div className="absolute top-20 left-10 animate-float opacity-30">
          <Plane className="w-12 h-12 text-white transform -rotate-45" />
        </div>
        <div className="absolute top-32 right-20 animate-float-delayed opacity-20">
          <Hotel className="w-10 h-10 text-white" />
        </div>
        <div className="absolute bottom-40 left-20 animate-float opacity-25">
          <Globe className="w-14 h-14 text-cyan-300" />
        </div>
        <div className="absolute top-40 left-1/4 animate-float-delayed opacity-20">
          <Briefcase className="w-8 h-8 text-white" />
        </div>
        <div className="absolute bottom-32 right-1/4 animate-float opacity-15">
          <Plane className="w-16 h-16 text-white transform rotate-12" />
        </div>
        
        {/* Gradient orbs */}
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-purple-400/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-80 h-80 bg-blue-400/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 right-1/3 w-64 h-64 bg-cyan-400/10 rounded-full blur-2xl"></div>
      </div>

      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-[70vh] pt-20 px-4">
        {/* Logo */}
        <div className="text-center mb-6">
          <div className="relative inline-block">
            <h1 className="text-[100px] md:text-[160px] font-bold text-white leading-none tracking-tight" style={{
            fontFamily: 'Cairo, sans-serif'
          }}>
              {__tr(t('brand'))}
            </h1>
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
              <span className="text-[#FF8C42] text-5xl md:text-6xl">✈</span>
            </div>
          </div>
          <p className="text-white/90 text-xl md:text-2xl mt-2 font-light tracking-wide">
            {__tr(language === 'ar' ? 'rehlaty' : "رحلتي")}
          </p>
        </div>

        {/* Tagline */}
        <div className="text-center mt-4">
          <p className="text-white text-lg md:text-xl font-light max-w-2xl">
            <span className="text-[#FF8C42]">✈️</span>
            <span className="mx-2">{__tr(t('brandTagline'))}</span>
          </p>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V120Z" fill="white" />
        </svg>
      </div>
    </div>;
};
export default HeroSection;
